import React from 'react'
import {
    StyledBreachContainer,
    StyledHeading,
    StyledPremiumLabel,
    StyledSubscriptionContainer,
    StyledSubscription,
    StyledSubscriptionHeading,
    StyledSubscriptionWrapper,
    StyledSubscribeButton,
    StyledLoginContainer,
    StyledParagraph,
    StyledBreachFooter,
    StyledOutlineAnchor,
    StyledContactDetails,
    StyledSubcriptionText,
    StyledWAFootyLogo,
    StyledPlusIcon,
    StyledDayRange,
    everydayDigitalClassName,
    ultimatePackClassName,
    StyledSubscriptionInfoContainer,
    StyledSubscriptionInfo,
    StyledSubcriptionSubtitle,
    StyledParagraphAboveMobile,
    StyledParagraphMobileOnly,
    StyledLogInButton,
} from './SportBreachNotification.styled'
import { BreachEvent } from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { AuthenticationState } from '@news-mono/web-common'
import { THEWEST_ALL } from '../../../../entitlements'
import { AuthenticationProvider } from '../../../../authentication'
import { createLinkClickEvent } from '../../../createLinkClickHandler'

const plusIcon = require('./assets/plus.png')

export interface SportBreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export function SportBreachNotification({
    articleId,
    breachDeal,
    breachCreativeName,
    onEvent,
}: SportBreachNotificationProps) {
    const { entitlements } = useSelector<AppState, AuthenticationState>(
        (state) => state.authentication,
    )

    const { isLoggedIn } = useSelector<AppState, AuthenticationState>(
        (state) => state.authentication,
    )

    // a returning user is a user who has registered, logged in, and has not completed a purchase
    const returningUser = isLoggedIn && !entitlements?.includes(THEWEST_ALL)

    return (
        <AuthenticationProvider onEvent={onEvent}>
            {({ createBreachSubscribeClickEvent, onLoginClick }) => (
                <StyledBreachContainer data-testid="SportBreachScreen">
                    <StyledHeading>
                        Subscribe to the West Australian
                    </StyledHeading>
                    <StyledPremiumLabel>
                        This article is available to subscribers who have
                        digital access included in their subscription.
                        {!isLoggedIn && (
                            <StyledLoginContainer>
                                {' '}
                                <StyledLogInButton onClick={onLoginClick}>
                                    Log in
                                </StyledLogInButton>
                            </StyledLoginContainer>
                        )}
                    </StyledPremiumLabel>
                    <StyledWAFootyLogo />
                    <StyledSubcriptionSubtitle>
                        <StyledSubcriptionText>
                            Don’t miss the latest footy news!
                        </StyledSubcriptionText>
                    </StyledSubcriptionSubtitle>
                    <StyledSubscriptionContainer>
                        <StyledSubscription className={ultimatePackClassName}>
                            <StyledSubscriptionWrapper>
                                <StyledSubscriptionHeading>
                                    The Footy Pack
                                </StyledSubscriptionHeading>
                                <StyledSubscriptionInfoContainer>
                                    <StyledSubscriptionInfo bold>
                                        Digital + Print
                                    </StyledSubscriptionInfo>
                                </StyledSubscriptionInfoContainer>
                                <StyledSubscriptionInfoContainer>
                                    <StyledSubscriptionInfo strikethrough>
                                        $13
                                    </StyledSubscriptionInfo>{' '}
                                    <StyledSubscriptionInfo bold>
                                        $7
                                    </StyledSubscriptionInfo>{' '}
                                    <StyledSubscriptionInfo>
                                        per week for 12 weeks*
                                    </StyledSubscriptionInfo>
                                </StyledSubscriptionInfoContainer>
                                <StyledSubscribeButton
                                    onClick={() => {
                                        createLinkClickEvent(
                                            breachCreativeName,
                                            breachDeal,
                                            onEvent,
                                        )()
                                        createBreachSubscribeClickEvent({
                                            offerCode: 'SPORT20',
                                            articleId,
                                            breachCreativeName,
                                            breachDeal,
                                            returningUser,
                                        })()
                                    }}
                                >
                                    Subscribe Now
                                </StyledSubscribeButton>
                                <StyledParagraph>
                                    Enjoy unlimited access to thewest.com.au and
                                    everyday digital editions on any device.
                                </StyledParagraph>
                                <StyledDayRange>
                                    <StyledParagraph marginTop bold>
                                        <StyledPlusIcon src={plusIcon} alt="" />
                                        Thursday – Monday
                                    </StyledParagraph>
                                </StyledDayRange>
                                <StyledParagraphAboveMobile bold>
                                    Home delivery, with the latest footy news,
                                    new look Pre-Game and The Game lift outs
                                    with fixtures, highlights and expert
                                    opinions from WA’s leading football writers.
                                </StyledParagraphAboveMobile>
                                <StyledParagraphMobileOnly bold>
                                    Papers home delivered with all the latest
                                    footy news!
                                </StyledParagraphMobileOnly>
                                <StyledParagraph marginTop>
                                    *T&Cs apply
                                </StyledParagraph>
                            </StyledSubscriptionWrapper>
                        </StyledSubscription>
                        <StyledSubscription
                            className={everydayDigitalClassName}
                        >
                            <StyledSubscriptionWrapper>
                                <StyledSubscriptionHeading>
                                    Everyday Digital
                                </StyledSubscriptionHeading>
                                <StyledSubscriptionInfoContainer>
                                    <StyledSubscriptionInfo bold>
                                        Digital only
                                    </StyledSubscriptionInfo>
                                </StyledSubscriptionInfoContainer>
                                <StyledSubscriptionInfoContainer>
                                    <StyledSubscriptionInfo bold>
                                        $7
                                    </StyledSubscriptionInfo>{' '}
                                    <StyledSubscriptionInfo>
                                        per week
                                    </StyledSubscriptionInfo>
                                </StyledSubscriptionInfoContainer>
                                <StyledSubscribeButton
                                    onClick={() => {
                                        createLinkClickEvent(
                                            breachCreativeName,
                                            breachDeal,
                                            onEvent,
                                        )()
                                        createBreachSubscribeClickEvent({
                                            offerCode: 'SPORTDIG',
                                            articleId,
                                            breachCreativeName,
                                            breachDeal,
                                            returningUser,
                                        })()
                                    }}
                                >
                                    Subscribe Now
                                </StyledSubscribeButton>
                                <StyledParagraph>
                                    Enjoy unlimited access to thewest.com.au
                                    PLUS daily digital editions of The West
                                    Australian and The Sunday Times on any
                                    device!
                                </StyledParagraph>
                            </StyledSubscriptionWrapper>
                        </StyledSubscription>
                    </StyledSubscriptionContainer>
                    <StyledBreachFooter>
                        {/* <StyledBreachFooterText></StyledBreachFooterText> */}
                        <StyledContactDetails>
                            Need Help? Call{' '}
                            <a href="tel:1800 811 855">1800 811 855</a> or view{' '}
                            <StyledOutlineAnchor
                                onClick={() => {
                                    createLinkClickEvent(
                                        breachCreativeName,
                                        breachDeal,
                                        onEvent,
                                    )()
                                    createBreachSubscribeClickEvent({
                                        articleId,
                                        breachCreativeName,
                                        breachDeal,
                                        returningUser,
                                    })()
                                }}
                                tabIndex={0}
                            >
                                all subscription packages
                            </StyledOutlineAnchor>
                        </StyledContactDetails>
                    </StyledBreachFooter>
                </StyledBreachContainer>
            )}
        </AuthenticationProvider>
    )
}
